import classNames from 'classnames';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import DoneImage from '../../../../../../assets/images/done.svg?url';
import profileImage from '../../../../../../assets/images/patients/profile.svg?url';
import useMixpanel, { componentType } from '../../../../../../hooks/useMixpanel';
import useIntakeData from '../../../../../../services/intakeDataService/index';
import { smsSentStatusEnum } from '../../../../../../services/intakeDataService/types';
import useRegistrationFlowData from '../../hooks/useRegistrationFlowData';
import CancelAction from '../../OnBoardingDrawerAction/CancelAction';
import { useOnBoardingDrawer } from '../../OnBoardingDrawerProvider';
import styles from './index.module.scss';
import EditPatientFormAction from './PatientDetailesForm/EditPatientFormAction';

const CreatedPatientDoneView = () => {
  const { activeStep, moveToStep, goToLastStep } = useOnBoardingDrawer();
  const methods = useForm();
  const {
    patientDetailesStep: { btnText, headerText, bodyTexts, mixpanelEventName },
  } = useRegistrationFlowData();
  const { state } = useIntakeData();
  const { trackClick } = useMixpanel();
  const onContinue = () => {
    state.updateSMSStatus(smsSentStatusEnum.inProgress);
    moveToStep(activeStep);
    if (mixpanelEventName) {
      trackClick({
        action: mixpanelEventName,
        component: componentType.registrationFlow,
      });
    }
  };
  return (
    <FormProvider {...methods}>
      <form
        className={classNames('flex flex-col items-center', styles.root)}
        onSubmit={onContinue}
      >
        <div className="flex flex-col items-center">
          <img alt={'Done icon'} src={DoneImage} className={styles.doneImage} />
          <h5 className={classNames('text-2xl font-bold text-center', styles.title)}>
            {headerText}
          </h5>
          <div className="mt-4">
            {bodyTexts?.map((text, index) => (
              <p
                key={`bodyText-${index}`}
                className={classNames('text-base text-center', styles.body)}
              >
                {text}
              </p>
            ))}
          </div>
        </div>
        <div className="flex flex-col items-center gap-4">
          <h5
            className={classNames('text-2xl font-bold text-left', styles.profileText)}
          >
            Patient information can be edited at any time through the 'Profile' tab on the patient's
            page.
          </h5>
          <img alt={'profile image'} src={profileImage} className={styles.profileImg} />
        </div>
        <CancelAction
          onClick={() => {
            state.updateSMSStatus(smsSentStatusEnum.Cancelled);
            goToLastStep();
          }}
          btnText="Finish Registration"
        />
        <EditPatientFormAction btnText={btnText} testid={'patient-done'} />
      </form>
    </FormProvider>
  );
};
export default CreatedPatientDoneView;
